export const mockpay1 = {
    data: {
        GenerarUrl: {
            error: "OK",
            success: true
        },
        idPago: "673de93a2400009f0fb20de6",
        QuoteId: "0Q0dq0000004ly1CAA",
        urlPago: "/pago/suratech/673de93a2400009f0fb20de6"
    },
    error: false
}

export const mockpay1Error = {
    data: {
        quoteId: "0Q0D5000000YXSlKAO",
        message: "No se pudo establecer conexión, hubo un problema con el servicio GenerarUrl"
    },
    error: true
}

// cosumo 2 

export const mockpay2 = {
    data: {
        success: true,
        data: {
            url: "https://ventaslab.suraenlinea.com/sarlaft/sura?idCotizacion=512300000317&urlRedireccion=https:%2f%2fpagoslab.suraenlinea.com%2fpago%2fsuratech%2f6733a8942400009c2ce3e2d3&validacion=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJhdXRoMCIsImV4cCI6MTczMjExMjUzOCwiaWF0IjoxNzMyMTEwNzM4LCJqdGkiOiI0ZGFmYTQzNS05ZTFkLTQzN2QtYjYwYy0yYzNkYWYwMWE1NWEifQ.KwONKOWy4-hTK5s2AaCzsA-vOnrVQ6-koBRsKOIhMCE5hrZfn_fJcS0orzszuvDNoIGUwIRIhfeoZY3WhhrPQA"
        },
        message: "URL generada exitosamente",
        status: "success"
    },
    error: false
}

export const mockpay2Error = {
    data: {
        quoteId: "0Q0dq0000007ScHCAU",
        message: "No se pudo establecer conexión con el servicio SARLAFT",
    },
    error: true
}

















































